import { render, staticRenderFns } from "./ClientesPorInteresse.vue?vue&type=template&id=43d42e38&"
import script from "./ClientesPorInteresse.vue?vue&type=script&lang=js&"
export * from "./ClientesPorInteresse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports